namespace $.$$ {

	export class $eve_app_page_components_alert extends $.$eve_app_page_components_alert {

		// Playground наследуется из view.tree

	}

}

